import { memo, useEffect, useState } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import {
  IconMy03,
  IconArrowDown02,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import * as S from './style';

interface IProps {
  value?: number | string | undefined;
  selectedValue?: number | string | undefined;
  type?: 'type1' | 'type2' | 'type3' | 'type4' | 'type5' | 'type6' | 'type7'; // type1: 모션, type2: square, type3: round, type4: text, type5: underBar, type6: round white
  mode?: string | undefined;
  text?: string;
  className?: string;
  my?: boolean;
  onClick?: () => void;
}

function LeaveMenuBarItem({
  value,
  selectedValue = '',
  text,
  className,
  type = 'type6',
  my = false,
  mode,
  onClick,
}: IProps) {
  const [activeValue, setActiveValue] = useState(String(value));
  const [$selectedValue, setSelectedValue] = useState(String(selectedValue));

  const cName = classNameBind([
    'menubar-item item',
    activeValue === $selectedValue ? 'active' : '',
    mode === 'filter' ? 'filter' : '',
    className || '',
  ]);

  useEffect(() => {
    setActiveValue(String(value));
    setSelectedValue(String(selectedValue));
  }, [selectedValue, value]);

  return (
    <S.LeaveMenuBarItem className={cName} type={type}>
      <Button className="area-click" onClick={onClick}>
        {my && <IconMy03 className="icon-my" />}
        {text}
        {mode === 'filter' && <IconArrowDown02 className="icon-filter" />}
      </Button>
    </S.LeaveMenuBarItem>
  );
}

export default memo(LeaveMenuBarItem);
